import { API_CONFIG } from '@/lib/config/api-config';

/**
 * Dynamically adds performance optimization hints to the document head
 * based on the current environment configuration
 */
export const addPerformanceHints = () => {
  // Get the current API base URL from configuration
  const apiBaseUrl = API_CONFIG.BASE_URL;
  
  // Extract domain from API URL
  const apiDomain = new URL(apiBaseUrl).hostname;
  
  // Known external domains that need optimization
  const externalDomains = [
    apiDomain,
    'monitoring.clearminds.se', // For network statistics
  ];

  // Add DNS prefetch and preconnect hints for each domain
  externalDomains.forEach(domain => {
    // DNS prefetch
    const dnsPrefetch = document.createElement('link');
    dnsPrefetch.rel = 'dns-prefetch';
    dnsPrefetch.href = `https://${domain}`;
    document.head.appendChild(dnsPrefetch);

    // Preconnect
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = `https://${domain}`;
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);
  });

};

/**
 * Removes performance hints (useful for cleanup)
 */
export const removePerformanceHints = () => {
  const hints = document.querySelectorAll('link[rel="dns-prefetch"], link[rel="preconnect"]');
  hints.forEach(hint => hint.remove());
};

export default addPerformanceHints; 